var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloudy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App-icon/Cloudy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.1668 17.1666C37.1668 15.8406 36.64 14.5688 35.7023 13.6311C34.7646 12.6934 33.4929 12.1666 32.1668 12.1666H28.4884C27.923 10.1772 26.7017 8.4373 25.0227 7.22952C23.3437 6.02174 21.3058 5.41701 19.2398 5.51354C17.1738 5.61006 15.2011 6.40217 13.6421 7.76123C12.0831 9.12028 11.0292 10.9665 10.6518 13M29.6668 35.5H15.5001C13.3365 35.4994 11.2158 34.8973 9.37473 33.7608C7.53371 32.6243 6.04497 30.9982 5.07489 29.0643C4.10481 27.1304 3.69159 24.9649 3.88142 22.8097C4.07126 20.6545 4.85665 18.5945 6.14985 16.8599C7.44305 15.1254 9.1931 13.7846 11.2044 12.9875C13.2158 12.1903 15.4092 11.9681 17.5395 12.3457C19.6699 12.7234 21.6532 13.686 23.268 15.126C24.8827 16.566 26.0653 18.4266 26.6834 20.5H29.6668C30.6517 20.5 31.627 20.694 32.5369 21.0709C33.4468 21.4478 34.2736 22.0002 34.9701 22.6967C35.6665 23.3931 36.219 24.2199 36.5959 25.1299C36.9728 26.0398 37.1668 27.0151 37.1668 28C37.1668 28.9849 36.9728 29.9602 36.5959 30.8701C36.219 31.78 35.6665 32.6068 34.9701 33.3033C34.2736 33.9997 33.4468 34.5522 32.5369 34.9291C31.627 35.306 30.6517 35.5 29.6668 35.5Z",
    stroke: "black",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloudy);
export default __webpack_public_path__ + "static/media/icon-cloudy.bcfecb1ca8f8526a1f3d0d3f75d06c11.svg";
export { ForwardRef as ReactComponent };